/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState, Fragment } from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

import './index.scss';

import { ItemsCreators } from '../../../store/actions/items';
import { BotsCreators } from '../../../store/actions/bots';
import * as CreatorAcions from '../../../store/actions/bot-creator';
import { ConnectorsCreators } from '../../../store/actions/connectors';
import { itemIconDoubleClick } from '../utils';

const Breadcrumbs = (props) => {
  const dispatch = useDispatch();
  const { bot, currentFlow, debounceList } = props;

  const { resetFlowPath } = useSelector((state) => state.botCreator);

  const [paths, setPaths] = useState([{ blockName: '', id: '' }]);

  useEffect(() => {
    if (bot) {
      if (resetFlowPath) {
        const { title, _id: id } = bot;

        const newPaths = [];

        newPaths.push({ blockName: title, id });

        setPaths(newPaths);

        dispatch(CreatorAcions.resetFlowPath(false));
      } else {
        const { title, _id: id } = bot;
        const newPaths = [...paths];
        newPaths[0] = { blockName: title, id };
        setPaths(newPaths);
      }
    }
  }, [bot]);

  useEffect(() => {
    const { _id } = bot;
    const { blockName, id } = currentFlow;
    const hasElement = paths.find((path) => path.id === id);
    if (_id && id && !hasElement && id !== _id) {
      const newPaths = [...paths];
      newPaths.push({ id, blockName });
      setPaths(newPaths);
    }
  }, [currentFlow]);

  const onClickPath = (path) => {
    const { _id: botId } = bot;
    const { setInicialGroupPosition } = props;
    if (path.id === currentFlow.id) {
      if (path.id === botId) {
        setInicialGroupPosition();
      }
      return;
    }

    const index = paths.indexOf(path);
    if (index !== -1) {
      const {
        changeCurrentFlow,
        listItemsRequest,
        getConnectorsRequest,
        getSubflowItems,
        getConnectorsSubflowRequest,
        showRightMenu,
      } = props;

      const { id, blockName } = path;
      const item = { _id: id, title: blockName };
      const { Group: reloadBuilder } = itemIconDoubleClick;
      const newPaths = [...paths];

      newPaths.splice(index + 1);
      setPaths(newPaths);
      reloadBuilder({
        botId,
        item,
        listItemsRequest,
        getConnectorsRequest,
        changeCurrentFlow,
        getSubflowItems,
        getConnectorsSubflowRequest,
        debounceList,
        groupTrigger: setInicialGroupPosition,
      });
      showRightMenu(undefined, undefined);
    }
  };

  const renderPaths = () => {
    if (paths.length === 0 || paths[0].id === '') {
      return false;
    }

    const { _id: botId } = bot;

    return paths.map((path, index) => {
      const { id, blockName } = path;
      let spanClass = '';
      if (id !== currentFlow.id || id === botId) {
        spanClass = 'builder-breadcrumb';
      }
      const divider =
        paths.length > 1 && paths.length !== index + 1 ? '  /' : '';

      return (
        <Fragment key={id}>
          <span id={id} className={spanClass} onClick={() => onClickPath(path)}>
            {blockName}
          </span>
          {divider}
        </Fragment>
      );
    });
  };

  return <Fragment>{renderPaths()}</Fragment>;
};

const mapStateToProps = (state) => ({
  currentFlow: state.items.currentFlow,
  bot: state.bots.bot,
  debounceList: state.debounce.list,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...BotsCreators, ...ItemsCreators, ...ConnectorsCreators },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Breadcrumbs);
